import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeWaterHeater } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeWaterHeater} />; }
